import { ErrorHandler, Injectable } from '@angular/core'

import { Kirjanpitaja } from '../../../_jaettu-lemonator/model/kirjanpitaja'
import { AsiakasService, AsiakkaanAvainTiedot } from '../asiakas/asiakas.service'

import { TimestampService } from '../../../_jaettu-angular/service/timestamp-service'

import { LaskuSharedService, ReskontraService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { LaskuIndeksoija } from '@lemon/core-firebase/service/lasku/lasku.indeksoija'
import { LaskuKopioija } from '@lemon/core-firebase/service/lasku/lasku.kopioija'
import { TranslationService } from '@lemon/core-firebase/service/translation.service'
import { TuettuKieli } from '@lemon/core/model/common'
import { DateService } from '@lemon/core/service/date.service'
import { Asiakas, Kayttaja } from '../../../_jaettu-lemonator/model/asiakas'

import { KayttajanTiedot } from '@lemon/core-firebase/model/kayttaja'
import {
  EI_LASKUNUMEROA_NUMERO,
  EmailLahetysStatus,
  EmailLahetysStatusKoodi,
  Lasku,
  LaskuBase,
  LaskuReskontra,
  LaskuToimintaloki,
  Laskuasetukset,
  LaskunAsiakas,
  LaskunAsiakastyyppi,
  LaskunLahetystapa,
  LaskunLiitetiedosto,
  LaskunListaustietorivi,
  LaskunSahkoinenOsoite,
  LaskunSahkopostipohja,
  LaskunSahkpostipohjanVari,
  LaskunToimintalokiTilastoParametrit,
  LaskunToimintalokiTyyppi,
  LaskunTyypit,
  LaskunumeroTyyppi,
  PeppolNameObject,
  PeppolNumberRequest,
  PeppolNumberResponse,
  PeppolNumberResponseEntity,
  PeppolValidaatioTulos,
  PurkuViestiTyojonoMerkinta,
  TilastoTiedot,
  ViestiTyyppi,
} from '@lemon/core-firebase/model/lasku'
import { FirestoreProvider, FirestoreWriteBatch, JuurilaskuJaKasiteltava, LaskuTallennusService } from '@lemon/core-firebase/service/lasku/lasku-tallennus.service'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { StringService } from '@lemon/core/service/string.service'
import { ViitenumeroService } from '@lemon/core/service/viitenumero.service'

import { Observable, firstValueFrom } from 'rxjs'
import { filter, map } from 'rxjs/operators'

import { LaskuLemonatoriinData, LemonaidToLemonatorExportTyojono, LemonaidToLemonatorExportType } from '@lemon/core-firebase/model/lemonaid-lemonator-shared-communications'
import { LaskuSpostiService } from '@lemon/core-firebase/service/lasku/lasku-sposti.service'
import { Timestamp } from '@lemon/core/model/common'
import { KirjautunutKayttajaService } from 'app/_angular/service/kirjautunut-kayttaja.service'
import { AlvService } from 'app/_jaettu-angular/service/alv.service'
import { KirjanpitajanAllekirjoitusService } from 'app/_jaettu-lemonator/service/kirjanpitajan-allekirjoitus.service'
import { KirjanpitajanTiimiService } from 'app/_jaettu-lemonator/service/kirjanpitajan-tiimi.service'
import { FirebaseLemonaid, FirebaseLemonator } from '../firebase-lemonator.service'

@Injectable()
export class LaskuService {
  private laskuTallennusService: LaskuTallennusService

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public LEMONTREE_ASIAKAS_ID = 9
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public LEMONTREE_ASIAKAS_AVAIN = 'jzATU474P4BRCkEANZ1H'

  asetuksetObservable: Observable<Laskuasetukset>
  private _firestoreProvider: FirestoreProvider

  constructor(
    private errorHandler: ErrorHandler,
    private dateService: DateService,
    private currencyService: CurrencyService,
    private reskontraService: ReskontraService,
    private translationService: TranslationService,
    private laskuUriService: LaskuUriService,
    private _firebase: FirebaseLemonator,
    private _firebaseLemonaid: FirebaseLemonaid,
    private timestampService: TimestampService,
    private _laskuSharedService: LaskuSharedService,
    private laskuKopioija: LaskuKopioija,
    private laskuIndeksoija: LaskuIndeksoija,
    private asiakasService: AsiakasService,
    private viitenumeroService: ViitenumeroService,
    private stringService: StringService,
    private _laskuSpostiService: LaskuSpostiService,
    private _alvService: AlvService,
    private _laskuUriService: LaskuUriService,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _tiimiService: KirjanpitajanTiimiService,
    private _kirjanpitajanAllekirjoitusService: KirjanpitajanAllekirjoitusService,
  ) {
    this._firestoreProvider = {
      annaDeleteArvo: () => {
        return this._firebaseLemonaid.firestoreDeleteMarker()
      },
      annaUusiAvain: () => {
        return this._firebaseLemonaid.firestoreCreateId()
      },
      // THIS IS REALLY COUNTERINTUITIVE, BUT THE DOC TYPE CONTAINS NO DATA
      // AND THESE DAYS OUR FRONT END FIREBASE INTEGRATION LIBRARY EXPECTS THE URI,
      // NOT THE DOC TO BE PRESENT!
      annaDoc: (uri: string) => {
        return uri
      },
      annaUusiBatch: () => {
        return this._firebaseLemonaid.firestoreBatch()
      },
    }

    this.laskuTallennusService = new LaskuTallennusService(
      this._laskuSharedService,
      this.laskuKopioija,
      this.laskuIndeksoija,
      this.currencyService,
      this.dateService,
      this.laskuUriService,
      this.translationService,
      this.timestampService,
      this.reskontraService,
      this._firestoreProvider,
      this.viitenumeroService,
      this.stringService,
    )

    const asetuksetUri = this._laskuUriService.getLaskuasetuksetUri(this.LEMONTREE_ASIAKAS_AVAIN, this.LEMONTREE_ASIAKAS_AVAIN)
    this.asetuksetObservable = this._firebaseLemonaid.firestoreDoc<Laskuasetukset>(asetuksetUri).listen()
  }

  getLaskuAsetuksetAsiakkaalleObservable(asiakasId: string, asiakasAvain: string): Observable<Laskuasetukset> {
    const asetuksetUri = this._laskuUriService.getLaskuasetuksetUri(asiakasAvain, asiakasAvain)
    return this._firebaseLemonaid.firestoreDoc<Laskuasetukset>(asetuksetUri).listen()
  }

  getLaskuObservable(id: string): Observable<Lasku> {
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(this.LEMONTREE_ASIAKAS_AVAIN, id)
    return this._firebaseLemonaid
      .firestoreDoc<Lasku>(laskuUri)
      .listen()
      .pipe(
        map(lasku => {
          if (lasku) {
            delete lasku['haku']
          }
          return lasku
        }),
      )
  }

  getLaskuObservableAsiakkaalle(asiakasAvain: string, id: string): Observable<Lasku> {
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(asiakasAvain, id)
    return this._firebaseLemonaid
      .firestoreDoc<Lasku>(laskuUri)
      .listen()
      .pipe(
        map(lasku => {
          if (lasku) {
            delete lasku['haku']
          }
          return lasku
        }),
      )
  }

  async vaihdaLaskunTilastoLemonator(uudetTilastotiedot: TilastoTiedot, juurilaskuOriginal: Lasku, kasiteltavaOriginal: LaskuBase, tallentavaKirjanpitaja: string): Promise<JuurilaskuJaKasiteltava> {
    const reskontraPromise = this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilaskuOriginal.avain)

    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: tallentavaKirjanpitaja,
    }

    const { juurilasku, kasiteltava, collector } = this.laskuTallennusService.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    kasiteltava.tilastot = uudetTilastotiedot
    collector.addChange(juurilasku, kasiteltava, 'tilastot', kasiteltava.tilastot)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    const batch = this._firestoreProvider.annaUusiBatch()

    // Lisää lokimerkinnät
    const parametrit: LaskunToimintalokiTilastoParametrit = {
      vanhaKirjanpitaja: kasiteltavaOriginal.tilastot?.kirjanpitaja ?? null,
      vanhaTiimi: kasiteltavaOriginal.tilastot?.tiimi ?? null,
      uusiKirjanpitaja: uudetTilastotiedot.kirjanpitaja ?? null,
      uusiTiimi: uudetTilastotiedot.tiimi ?? null,
    }
    this.laskuTallennusService.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.TILASTO_UPDATE, juurilasku, kasiteltava, batch, parametrit)

    // Prepare for save
    this.laskuTallennusService.valmisteleTallennettavaksi(juurilasku, kasiteltava, await reskontraPromise, collector)

    // Tallenna lasku
    this.laskuTallennusService.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this._firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Vaihda tilasto
    this._paivitaTilastoLemonator(juurilasku.avain, this._firestoreProvider, batch)

    // Tallenna Postgres työjono
    this.laskuTallennusService.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    this.laskuTallennusService.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    await batch.commit()
    return { juurilasku, kasiteltava }
  }

  private _paivitaTilastoLemonator(juurilaskuAvain: string, firestore: FirestoreProvider, batch: FirestoreWriteBatch) {
    const tyojono: LemonaidToLemonatorExportTyojono = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      aloitettu: this.timestampService.now(),
      type: LemonaidToLemonatorExportType.TILASTO_UPDATE,
    }

    const tyojonoData: LaskuLemonatoriinData = {
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      laskunAvain: juurilaskuAvain,
      luotu: this.timestampService.now(),
    }

    const tyojonoId = this._firestoreProvider.annaUusiAvain()

    const tyojonoUri = 'tyojono/' + this.LEMONTREE_ASIAKAS_AVAIN + '/data-lemonatoriin/' + tyojonoId
    const tyojonoDoc = firestore.annaDoc(tyojonoUri)

    const tyojonoDataUri = 'tyojono-data/' + this.LEMONTREE_ASIAKAS_AVAIN + '/data-lemonatoriin/' + tyojonoId
    const tyojonoDataDoc = firestore.annaDoc(tyojonoDataUri)

    batch.set(tyojonoDoc, tyojono)
    batch.set(tyojonoDataDoc, tyojonoData)
  }

  async paivitaTilaJaIndeksoiUudelleen(juurilasku: Lasku, asiakas: AsiakkaanAvainTiedot, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(asiakas.avain, juurilasku.avain)
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: asiakas.avain,
      asiakasId: asiakas.asiakasId + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.paivitaTilaJaIndeksoiUudelleen(kayttajanTiedot, juurilasku, reskontra)
  }

  async indeksoiUudelleen(juurilasku: Lasku, asiakas: AsiakkaanAvainTiedot, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(asiakas.avain, juurilasku.avain)
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: asiakas.avain,
      asiakasId: asiakas.asiakasId + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.indeksoiUudelleen(kayttajanTiedot, juurilasku, reskontra)
  }

  async laskeReskontraUudelleen(juurilasku: Lasku, asiakas: AsiakkaanAvainTiedot, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: asiakas.avain,
      asiakasId: asiakas.asiakasId + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await this._getLaskuReskontra(asiakas.avain, juurilasku.avain)
    return this.laskuTallennusService.laskeReskontraUudelleen(kayttajanTiedot, juurilasku, reskontra)
  }

  async merkitseLaskuLahetetyksiSpostilla(
    asiakas: Asiakas,
    kirjanpitaja: Kirjanpitaja,
    templateId: number,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    vastaanottajat: EmailLahetysStatus[],
    aihe: string,
    otsikko: string,
    teksti: string,
    slogan: string,
    varit: { [key in LaskunSahkpostipohjanVari]: string },
  ): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)

    // Asetetaan asiakkaan avain
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.merkitseLaskuLahetetyksiSpostilla({
      kayttajanTiedot,
      templateId,
      juurilaskuOriginal: juurilasku,
      kasiteltavaOriginal: kasiteltava,
      reskontra,
      vastaanottajat,
      aihe,
      otsikko,
      teksti,
      slogan,
      tasapainoitaEnsinKayttaenViitenumeroa: asiakas.viitenumero,
      varit,
      footer: 'footer1',
      logoInFooter: true,
      ostavanAsiakkaanAvain: asiakas.avain,
    })
  }

  async merkitseLaskuLahetetyksiTulostamallaToisenHyvaksyntajonoon(
    asiakas: Asiakas,
    osoite: LaskunSahkoinenOsoite,
    kirjanpitaja: Kirjanpitaja,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
  ): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)

    // Asetetaan asiakkaan avain
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.merkitseLaskuLahetetyksiTulostamallaToisenHyvaksyntajonoon(kayttajanTiedot, osoite, juurilasku, kasiteltava, reskontra, null, asiakas.viitenumero, asiakas.avain)
  }

  async merkitseLaskuLahetetyksiSahkoisesti(asiakas: Asiakas, osoite: LaskunSahkoinenOsoite, kirjanpitaja: Kirjanpitaja, juurilasku: Lasku, kasiteltava: LaskuBase): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)

    // Asetetaan asiakkaan avain
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.merkitseLaskuLahetetyksiSahkoisesti(kayttajanTiedot, osoite, juurilasku, kasiteltava, reskontra, null, asiakas.viitenumero, asiakas.avain)
  }

  async merkitseLaskunMaksumuistutusLahetetyksiSpostilla(
    asiakas: Asiakas,
    kirjanpitaja: Kirjanpitaja,
    templateId: number,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    vastaanottajat: EmailLahetysStatus[],
    aihe: string,
    otsikko: string,
    teksti: string,
    slogan: string,
    paivitaAsiakkaanSaajat: boolean,
  ): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)

    // Asetetaan asiakkaan avain
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.merkitseLaskunMaksumuistutusLahetetyksiSpostilla({
      kayttajanTiedot,
      templateId,
      juurilaskuOriginal: juurilasku,
      kasiteltavaOriginal: kasiteltava,
      reskontra,
      vastaanottajat,
      aihe,
      otsikko,
      teksti,
      slogan,
      paivitaLahettajatAsiakkaaseen: paivitaAsiakkaanSaajat,
      ostavanAsiakkaanAvain: asiakas.avain,
    })
  }

  async merkitseLaskunMaksumuistutusLahetetyksiTulostamalla(asiakas: Asiakas, kirjanpitaja: Kirjanpitaja, juurilasku: Lasku, kasiteltava: LaskuBase): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)

    // Asetetaan asiakkaan avain
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.merkitseLaskunMaksumuistutusLahetetyksiTulostamalla(kayttajanTiedot, juurilasku, kasiteltava, reskontra, null, asiakas.avain)
  }

  async merkitseLaskuLahetetyksiTulostamalla(asiakas: Asiakas, kirjanpitaja: Kirjanpitaja, juurilasku: Lasku, kasiteltava: LaskuBase): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)

    // Asetetaan asiakkaan avain
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.merkitseLaskuLahetetyksiTulostamalla({
      kayttajanTiedot,
      juurilasku,
      kasiteltava,
      reskontra,
      tasapainoitaEnsinKayttaenViitenumeroa: asiakas.viitenumero,
      ostavanAsiakkaanAvain: asiakas.avain,
    })
  }

  async merkitsePurkuViestiLahetetyksi(asiakas: LaskunAsiakas, juurilaskunAvain: string, tyyppi: ViestiTyyppi, kirjanpitaja: Kirjanpitaja) {
    const lahetyksenAvain = this._firestoreProvider.annaUusiAvain()
    const tyojonoData: PurkuViestiTyojonoMerkinta = {
      asiakasAvain: asiakas.avain,
      juurilaskuAvain: juurilaskunAvain,
      lahetyksenAvain: lahetyksenAvain,
      tyyppi: tyyppi,
      luoja: kirjanpitaja.avain,
      aloitettu: this.timestampService.now(),
      uudelleenyrityksia: 0,
    }

    const batch = this._firebase.firestoreBatch()
    const tyojonoUri = 'tyojono/' + asiakas.avain + '/purku_emailit/' + lahetyksenAvain

    batch.set(tyojonoUri, tyojonoData)
    await batch.commit()
  }

  async lahetaEmailUudelleen(
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    asiakas: Asiakas,
    kirjanpitaja: Kirjanpitaja,
    vastaanottaja: EmailLahetysStatus,
    vanhaEmail: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    // Päivitä virheellinen email Lemonator asiakkaassa
    if (asiakas.laskunVastaanottajat) {
      const index = asiakas.laskunVastaanottajat.indexOf(vanhaEmail)
      if (index > -1) {
        asiakas.laskunVastaanottajat.splice(index, 1)
      }
    } else {
      asiakas.laskunVastaanottajat = []
    }
    asiakas.laskunVastaanottajat.push(vastaanottaja.email)
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    return this.laskuTallennusService.lahetaEmailUudelleen(kayttajanTiedot, juurilasku, kasiteltava, reskontra, vastaanottaja, vanhaEmail)
  }

  async lahetaSahkoinenUudelleen(juurilasku: Lasku, kasiteltava: LaskuBase, asiakas: Asiakas, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    asiakas.sahkoinenLaskutusosoite = kasiteltava.sahkoinen.osoite
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    return this.laskuTallennusService.lahetaSahkoinenUudelleen(kayttajanTiedot, juurilasku, kasiteltava, reskontra)
  }

  haeLaskunumeroArvio(lasku: LaskuBase): Promise<number> {
    if (this._laskuSharedService.onkoUlkoinenLasku(lasku)) {
      return null
    }

    if (lasku.nro && lasku.nro !== EI_LASKUNUMEROA_NUMERO) {
      return Promise.resolve(lasku.nro)
    }
    const numerotyyppi = lasku.nrotyyppi === LaskunumeroTyyppi.HYVITYS ? LaskunumeroTyyppi.TAVALLINEN : lasku.nrotyyppi
    return this.getLaskunumeroInternal(lasku.pvm, lasku.avain, numerotyyppi).then(number => {
      const year = lasku.pvm.toDate().getFullYear().toString().substring(2)
      return Number(year + number)
    })
  }

  private async getLaskunumeroInternal(laskupvm: Timestamp, laskuid: string, tyyppi: LaskunumeroTyyppi): Promise<number> {
    const uri = '/laskut/nrot/' + this.LEMONTREE_ASIAKAS_ID + '/' + tyyppi + '/' + laskupvm.toDate().getFullYear()
    return this._firebaseLemonaid.databaseGet(uri).then(snapshot => {
      const values = snapshot.val()
      if (values) {
        if (laskuid) {
          let index = 1
          for (const numero of values) {
            if (numero === laskuid) {
              return index
            }
            index++
          }
          return index
        } else {
          return values.length + 1
        }
      } else {
        return 1
      }
    })
  }

  getLaskuReskontraObservableAsiakkaalle(asiakasAvain: string, laskuAvain: string): Observable<LaskuReskontra[]> {
    const uri = this.laskuUriService.getCustomerLaskunReskontraCollectionUri(asiakasAvain, laskuAvain)
    return this._firebaseLemonaid.firestoreCollection<LaskuReskontra>(uri).orderBy('pvm', 'asc').listen()
  }

  getLaskuToimintalokiObservableAsiakkaalle(asiakasAvain: string, laskuAvain: string): Observable<LaskuToimintaloki[]> {
    const uri = this.laskuUriService.getCustomerLaskunToimintalokiCollectionUri(asiakasAvain, laskuAvain)
    return this._firebaseLemonaid.firestoreCollection<LaskuToimintaloki>(uri).orderBy('pvm', 'asc').orderBy('toiminto', 'asc').listen()
  }

  private _getLaskuReskontra(asiakasAvain: string, laskuAvain: string): Promise<LaskuReskontra[]> {
    return firstValueFrom(this.getLaskuReskontraObservableAsiakkaalle(asiakasAvain, laskuAvain).pipe(filter(rskntr => !!rskntr)))
  }

  getLaskuReskontraObservable(laskuAvain: string): Observable<LaskuReskontra[]> {
    const uri = this.laskuUriService.getCustomerLaskunReskontraCollectionUri(this.LEMONTREE_ASIAKAS_AVAIN, laskuAvain)
    return this._firebaseLemonaid.firestoreCollection<LaskuReskontra>(uri).orderBy('pvm', 'asc').listen()
  }

  getLaskuToimintalokiObservable(laskuAvain: string): Observable<LaskuToimintaloki[]> {
    const uri = this.laskuUriService.getCustomerLaskunToimintalokiCollectionUri(this.LEMONTREE_ASIAKAS_AVAIN, laskuAvain)
    return this._firebaseLemonaid.firestoreCollection<LaskuToimintaloki>(uri).orderBy('pvm', 'asc').orderBy('toiminto', 'asc').listen()
  }

  getLiitetiedostoUriAsiakkaalle(asiakasAvain: string, liitetiedosto: LaskunLiitetiedosto): string {
    return this.laskuUriService.annaLiitetiedostonCloudStorageUri(asiakasAvain, liitetiedosto)
  }

  getLiitetiedostoUri(liitetiedosto: LaskunLiitetiedosto): string {
    return this.laskuUriService.annaLiitetiedostonCloudStorageUri(this.LEMONTREE_ASIAKAS_AVAIN, liitetiedosto)
  }

  getPdfUrlAsiakkaalle(asiakasId: string, lasku: LaskuBase): string {
    return this.laskuUriService.getPdfUri(asiakasId, lasku.avain)
  }

  getPdfUrl(lasku: LaskuBase): string {
    return this.laskuUriService.getPdfUri(this.LEMONTREE_ASIAKAS_ID, lasku.avain)
  }

  annaPdfTiedostonNimi(juurilasku: Lasku, kasiteltava: LaskuBase, kieli: TuettuKieli): string {
    let nimi = this.translationService.lokalisoi('lasku.tiedostonimen-alku-ladattaessa', kieli)
    const laskunumero = this._laskuSharedService.annaMuotoiltuLaskunumero(juurilasku, kasiteltava)
    if (laskunumero) {
      nimi += ' ' + laskunumero
    }
    if (kasiteltava && kasiteltava.asiakas && kasiteltava.asiakas.nimi) {
      nimi += ' ' + kasiteltava.asiakas.nimi
    }
    if (kasiteltava && kasiteltava.pvm) {
      nimi += ' ' + this.dateService.muotoilePaiva(kasiteltava.pvm, kieli)
    }
    nimi += '.pdf'

    return nimi
  }

  public lemonatorAsiakasLaskunAsiakkaaksi(asiakas: Asiakas): LaskunAsiakas {
    return {
      avain: asiakas.avain,
      date: this.timestampService.now(),
      katuosoite: asiakas.katuosoite,
      laskunKieli: asiakas.laskunKieli || 'fi',
      laskunTyyppi: asiakas.laskunTyyppi || LaskunTyypit.TAVALLINEN.avain,
      laskunValuutta: asiakas.laskunValuutta || 'EUR',
      laskunVastaanottajat: asiakas.laskunVastaanottajat || [],
      maa: asiakas.maa,
      nimi: asiakas.nimi,
      postinro: asiakas.postinro,
      postitmp: asiakas.postitmp,
      ytunnus: asiakas.ytunnus,
      asiakastyyppi: LaskunAsiakastyyppi.YRITYS, // Kaikki Lemonatorin asiakkaat ovat yrityksiä
      sahkoinenosoite: {
        sahkoinenOsoite: null,
        sahkoinenValittaja: null,
      },
      viimeisinLaskuLahetetty: LaskunLahetystapa.SAHKOPOSTI,
    }
  }

  async lahetaLaskuUudelleen(juurilasku: Lasku, kasiteltava: LaskuBase, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    return this.laskuTallennusService.lahetaLaskuUudelleen(kayttajanTiedot, juurilasku, kasiteltava, reskontra)
  }

  async lahetaUudelleenSpostilla(
    asiakas: Asiakas,
    kirjanpitaja: Kirjanpitaja,
    templateId: number,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    vastaanottajat: EmailLahetysStatus[],
    aihe: string,
    otsikko: string,
    teksti: string,
    slogan: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.lahetaUudelleenSpostilla({
      kayttajanTiedot,
      templateId,
      juurilaskuOriginal: juurilasku,
      kasiteltavaOriginal: kasiteltava,
      reskontra,
      vastaanottajat,
      aihe,
      otsikko,
      teksti,
      slogan,
      ostavanAsiakkaanAvain: asiakas.avain,
    })
  }

  async lahetaUudelleenSahkoisesti(asiakas: Asiakas, osoite: LaskunSahkoinenOsoite, kirjanpitaja: Kirjanpitaja, juurilasku: Lasku, kasiteltava: LaskuBase): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.lahetaUudelleenSahkoisesti({
      kayttajanTiedot,
      osoite,
      juurilaskuOriginal: juurilasku,
      kasiteltavaOriginal: kasiteltava,
      reskontra,
      ostavanAsiakkaanAvain: asiakas.avain,
    })
  }

  async lahetaUudelleenTulostamalla(asiakas: Asiakas, kirjanpitaja: Kirjanpitaja, juurilasku: Lasku, kasiteltava: LaskuBase): Promise<JuurilaskuJaKasiteltava> {
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    kasiteltava.asiakas.avain = asiakas.avain
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    return this.laskuTallennusService.lahetaUudelleenTulostamalla({
      kayttajanTiedot,
      juurilaskuOriginal: juurilasku,
      kasiteltavaOriginal: kasiteltava,
      reskontra,
      ostavanAsiakkaanAvain: asiakas.avain,
    })
  }

  async sendLemonTreeSecondReminderInvoice(alkuperainenLasku: Lasku, lahettajanLaskuasetukset: Laskuasetukset): Promise<JuurilaskuJaKasiteltava> {
    const lasku = this.laskuKopioija.copyLasku(alkuperainenLasku)
    const kasiteltava = this._laskuSharedService.annaViimeisinTavallinenLasku(lasku)
    const asiakas = await this._firebase.firestoreDoc<Asiakas>('asiakkaat/' + kasiteltava.asiakas.avain).get()

    const lang = kasiteltava.kieli || 'fi'
    const postmarkTemplateId = this._laskuSpostiService.annaSahkopostipohjanPostmarkNumero(LaskunSahkopostipohja.MUISTUTUS_LEMONTREE, lang)

    const laskunAsiakas = this.lemonatorAsiakasLaskunAsiakkaaksi(asiakas)
    const laskunTyyppi = LaskunTyypit.annaLaskunTyyppi(kasiteltava.tyyppi)
    if (!laskunTyyppi) {
      throw new Error('Ei LaskunTyyppiä avaimella: ' + kasiteltava.tyyppi)
    }

    const alvt = await this._alvService.annaLaskutyypinAlvt(laskunTyyppi, asiakas.maa)
    if (!alvt?.length) {
      throw new Error('Ei ALV-määrityksiä tyypille ' + laskunTyyppi.avain + ' ja maalle ' + asiakas.maa)
    }

    const muokattavaksiKasiteltava = this.laskuKopioija.kopioiLaskuMuistutusLaskuksi(lasku, kasiteltava, laskunAsiakas, alvt)
    this.laskuKopioija.korvaaJatkuvatTuotteetKorjaustuotteilla(muokattavaksiKasiteltava.kopioitu)
    // Lisätään kirjautunut kirjanpitäjä tilaston omistajaksi
    await this.asetaLaskunTilastoksiKirjautunutkirjanpitaja(muokattavaksiKasiteltava.kopioitu)
    this._laskuSharedService.lisaaLiittyviinLaskuihinIlmanMuutostenKeraamista(lasku, muokattavaksiKasiteltava.kopioitu)

    const muikkariAsetukset = lahettajanLaskuasetukset.muistutusSpostiasetukset ? lahettajanLaskuasetukset.muistutusSpostiasetukset[muokattavaksiKasiteltava.kopioitu.kieli] : null
    const rawAihe = muikkariAsetukset?.aihe || this._laskuSharedService.annaLokalisoituMerkkijono('lasku.spostipohjat.oletukset.muistutussposti.aihe', muokattavaksiKasiteltava.kopioitu)
    const rawOtsikko = muikkariAsetukset?.otsikko || this._laskuSharedService.annaLokalisoituMerkkijono('lasku.spostipohjat.oletukset.muistutussposti.otsikko', muokattavaksiKasiteltava.kopioitu)
    const rawTeksti = muikkariAsetukset?.teksti || this._laskuSharedService.annaLokalisoituMerkkijono('lasku.spostipohjat.oletukset.muistutussposti.teksti', muokattavaksiKasiteltava.kopioitu)
    const aihe = this._laskuSpostiService.korvaaMuuttujat(rawAihe, lahettajanLaskuasetukset, lasku, muokattavaksiKasiteltava.kopioitu)
    const otsikko = this._laskuSpostiService.korvaaMuuttujat(rawOtsikko, lahettajanLaskuasetukset, lasku, muokattavaksiKasiteltava.kopioitu)
    const teksti = this._laskuSpostiService.korvaaMuuttujat(rawTeksti, lahettajanLaskuasetukset, lasku, muokattavaksiKasiteltava.kopioitu)

    const kayttajanTiedot: KayttajanTiedot = {
      uid: 'lemonator_system',
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
    }

    // Toinen muistutus menee perintäritarille
    const perintaritariEmailStatus: EmailLahetysStatus[] = [
      {
        email: 'lemontree@perintaritari.com',
        status: EmailLahetysStatusKoodi.PROSESSOIDAAN,
        viesti: null,
      },
    ]

    const allekirjoitusHtml = this._kirjanpitajanAllekirjoitusService.getHallintoSignatureTemplate('https://storage.googleapis.com/lemon-public-images/lemon-tree-logo.jpg', lang, true)

    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, alkuperainenLasku.avain)
    return this.laskuTallennusService.merkitseLaskunMaksumuistutusLahetetyksiSpostilla({
      kayttajanTiedot,
      templateId: postmarkTemplateId,
      juurilaskuOriginal: lasku,
      kasiteltavaOriginal: muokattavaksiKasiteltava.kopioitu,
      reskontra,
      vastaanottajat: perintaritariEmailStatus,
      aihe,
      otsikko,
      teksti,
      slogan: lahettajanLaskuasetukset.slogan,
      paivitaLahettajatAsiakkaaseen: false,
      allekirjoitusHtml,
    })
  }

  async asetaLaskunTilastoksiKirjautunutkirjanpitaja(lasku: LaskuBase): Promise<void> {
    const kirjanpitaja = await firstValueFrom(this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable)
    if (!kirjanpitaja?.uid) {
      throw new Error('Kirjautunut kirjanpitäjä puuttuu')
    }
    const tiimi = await this._tiimiService.annaKirjanpitajanEnsimmainenTiimi(kirjanpitaja.uid, this.dateService.currentNumberDate())

    lasku.tilastot = {
      kirjanpitaja: kirjanpitaja.uid,
      tiimi: tiimi?.avain ?? null,
    }
  }

  async sendLemonTreeReminderInvoice(alkuperainenLasku: Lasku, lahettajanLaskuasetukset: Laskuasetukset): Promise<JuurilaskuJaKasiteltava> {
    const lasku = this.laskuKopioija.copyLasku(alkuperainenLasku)
    const kasiteltava = this._laskuSharedService.annaViimeisinTavallinenLasku(lasku)
    const asiakasPromise = this._firebase.firestoreDoc<Asiakas>('asiakkaat/' + kasiteltava.asiakas.avain).get()
    const asiakkaanKayttajatPromise = this._firebase.firestoreCollection<Kayttaja>('asiakkaat/' + kasiteltava.asiakas.avain + '/kayttajat').get()

    const [asiakas, asiakkaanKayttajat] = await Promise.all([asiakasPromise, asiakkaanKayttajatPromise])

    const lang = kasiteltava.kieli || 'fi'
    const postmarkTemplateId = this._laskuSpostiService.annaSahkopostipohjanPostmarkNumero(LaskunSahkopostipohja.MUISTUTUS_LEMONTREE, lang)

    const laskunAsiakas = this.lemonatorAsiakasLaskunAsiakkaaksi(asiakas)
    const laskunTyyppi = LaskunTyypit.annaLaskunTyyppi(kasiteltava.tyyppi)
    if (!laskunTyyppi) {
      throw new Error('Ei LaskunTyyppiä avaimella: ' + kasiteltava.tyyppi)
    }

    const alvt = await this._alvService.annaLaskutyypinAlvt(laskunTyyppi, asiakas.maa)
    if (!alvt?.length) {
      throw new Error('Ei ALV-määrityksiä tyypille ' + laskunTyyppi.avain + ' ja maalle ' + asiakas.maa)
    }

    const muokattavaksiKasiteltava = this.laskuKopioija.kopioiLaskuMuistutusLaskuksi(lasku, kasiteltava, laskunAsiakas, alvt, 3)
    this.laskuKopioija.korvaaJatkuvatTuotteetKorjaustuotteilla(muokattavaksiKasiteltava.kopioitu)
    // Lisätään kirjautunut kirjanpitäjä tilaston omistajaksi
    await this.asetaLaskunTilastoksiKirjautunutkirjanpitaja(muokattavaksiKasiteltava.kopioitu)
    this._laskuSharedService.lisaaLiittyviinLaskuihinIlmanMuutostenKeraamista(lasku, muokattavaksiKasiteltava.kopioitu)

    const muikkariAsetukset = lahettajanLaskuasetukset.muistutusSpostiasetukset ? lahettajanLaskuasetukset.muistutusSpostiasetukset[muokattavaksiKasiteltava.kopioitu.kieli] : null
    const rawAihe = muikkariAsetukset?.aihe || this._laskuSharedService.annaLokalisoituMerkkijono('lasku.spostipohjat.oletukset.muistutussposti.aihe', muokattavaksiKasiteltava.kopioitu)
    const rawOtsikko = muikkariAsetukset?.otsikko || this._laskuSharedService.annaLokalisoituMerkkijono('lasku.spostipohjat.oletukset.muistutussposti.otsikko', muokattavaksiKasiteltava.kopioitu)
    const rawTeksti = muikkariAsetukset?.teksti || this._laskuSharedService.annaLokalisoituMerkkijono('lasku.spostipohjat.oletukset.muistutussposti.teksti', muokattavaksiKasiteltava.kopioitu)
    const aihe = this._laskuSpostiService.korvaaMuuttujat(rawAihe, lahettajanLaskuasetukset, lasku, muokattavaksiKasiteltava.kopioitu)
    const otsikko = this._laskuSpostiService.korvaaMuuttujat(rawOtsikko, lahettajanLaskuasetukset, lasku, muokattavaksiKasiteltava.kopioitu)
    const teksti = this._laskuSpostiService.korvaaMuuttujat(rawTeksti, lahettajanLaskuasetukset, lasku, muokattavaksiKasiteltava.kopioitu)

    let aktiivisetYhteyshenkilot = asiakkaanKayttajat.filter(kayttaja => kayttaja.aktiivinen && kayttaja.roolit.HALLINTO_YHTEYSHENKILO)

    if (aktiivisetYhteyshenkilot.length < 1) {
      aktiivisetYhteyshenkilot = asiakkaanKayttajat.length === 1 ? asiakkaanKayttajat : null
    }

    if (!aktiivisetYhteyshenkilot) {
      throw new Error('Asiakkalla ' + lasku.asiakas.nimi + ' ei ole aktiivista yhteyshenkilöä.')
    }

    const kayttajanTiedot: KayttajanTiedot = {
      uid: 'lemonator_system',
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
    }

    const aktiivisetYhteyshenkilotEmailStatus: EmailLahetysStatus[] = aktiivisetYhteyshenkilot.map(henkilo => {
      const status: EmailLahetysStatus = {
        email: henkilo.email,
        status: EmailLahetysStatusKoodi.PROSESSOIDAAN,
        viesti: null,
      }
      return status
    })

    const allekirjoitusHtml = this._kirjanpitajanAllekirjoitusService.getHallintoSignatureTemplate('https://storage.googleapis.com/lemon-public-images/lemon-tree-logo.jpg', lang, true)

    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, alkuperainenLasku.avain)
    return this.laskuTallennusService.merkitseLaskunMaksumuistutusLahetetyksiSpostilla({
      kayttajanTiedot,
      templateId: postmarkTemplateId,
      juurilaskuOriginal: lasku,
      kasiteltavaOriginal: muokattavaksiKasiteltava.kopioitu,
      reskontra,
      vastaanottajat: aktiivisetYhteyshenkilotEmailStatus,
      aihe,
      otsikko,
      teksti,
      slogan: lahettajanLaskuasetukset.slogan,
      paivitaLahettajatAsiakkaaseen: false,
      allekirjoitusHtml,
    })
  }

  annaPdfTiedostonNimiAsiakkaalle(asiakas: Asiakas, juurilasku: Lasku, kasiteltava: LaskuBase, kieli: TuettuKieli): string {
    let nimi = 'Lemon Treen asiakkaan ' + asiakas.nimi + ' (' + asiakas.ytunnus + ') lasku '
    const laskunumero = this._laskuSharedService.annaMuotoiltuLaskunumero(juurilasku, kasiteltava)
    if (laskunumero) {
      nimi += ' ' + laskunumero
    }
    if (kasiteltava && kasiteltava.asiakas && kasiteltava.asiakas.nimi) {
      nimi += ' heidän asiakkaalle ' + kasiteltava.asiakas.nimi
    }
    if (kasiteltava && kasiteltava.pvm) {
      nimi += ' ' + this.dateService.muotoilePaiva(kasiteltava.pvm, kieli)
    }
    nimi += '.pdf'

    return nimi
  }

  async tallennaKommentti(juurilasku: Lasku, kirjanpitaja: Kirjanpitaja, kommentti: string): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    const kasiteltava = this._laskuSharedService.annaViimeisinTavallinenLasku(juurilasku) ?? this._laskuSharedService.annaViimeisinKasiteltavaLasku(juurilasku)
    return this.laskuTallennusService.tallennaKommentti(kayttajanTiedot, juurilasku, kasiteltava, reskontra, kommentti)
  }

  async merkitseLuottotappioksi(juurilasku: Lasku, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    const viimeisinTavallinen = this._laskuSharedService.annaViimeisinTavallinenLasku(juurilasku)
    return this.laskuTallennusService.merkitseLuottotappioksi(kayttajanTiedot, juurilasku, viimeisinTavallinen, reskontra)
  }

  async peruutaLuottotappiomerkinta(juurilasku: Lasku, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    const viimeisinTavallinen = this._laskuSharedService.annaViimeisinTavallinenLasku(juurilasku)
    return this.laskuTallennusService.peruutaLuottotappiomerkinta(kayttajanTiedot, juurilasku, viimeisinTavallinen, reskontra)
  }

  async lisaaReskontraMerkinta(juurilasku: Lasku, suoritus: number, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await this._getLaskuReskontra(this.LEMONTREE_ASIAKAS_AVAIN, juurilasku.avain)
    const kasiteltava = this._laskuSharedService.annaViimeisinTavallinenLasku(juurilasku)
    return this.laskuTallennusService.lisaaReskontraMerkinta(kayttajanTiedot, juurilasku, kasiteltava, reskontra, suoritus)
  }

  async merkitseLaskuTaysinMaksetuksi(listaustieto: LaskunListaustietorivi, kirjanpitaja: Kirjanpitaja): Promise<JuurilaskuJaKasiteltava> {
    const kayttajanTiedot: KayttajanTiedot = {
      asiakasAvain: this.LEMONTREE_ASIAKAS_AVAIN,
      asiakasId: this.LEMONTREE_ASIAKAS_ID + '',
      uid: kirjanpitaja.lemonaidUid,
    }
    const reskontra = await firstValueFrom(this.getLaskuReskontraObservable(listaustieto.juurilasku.avain).pipe(filter(rskntr => !!rskntr)))
    const juurilasku = await this.getLaskuAsiakkaalle(kayttajanTiedot.asiakasAvain, listaustieto.juuriAvain)
    return this.laskuTallennusService.merkitseLaskuTaysinMaksetuksi(kayttajanTiedot, juurilasku, reskontra)
  }

  async getLaskuAsiakkaalle(asiakasAvain: string, id: string): Promise<Lasku | null> {
    return firstValueFrom(this.getLaskuObservableAsiakkaalle(asiakasAvain, id))
  }

  async haeAsiakas(kasiteltava: LaskuBase): Promise<Asiakas | null> {
    if (kasiteltava && kasiteltava.asiakas && kasiteltava.asiakas.avain) {
      return firstValueFrom(this.getAsiakasObservable(kasiteltava.asiakas))
    }
    return Promise.resolve(null)
  }

  private getAsiakasObservable(laskunAsiakas: LaskunAsiakas): Observable<Asiakas | null> {
    return this._firebase
      .firestoreDoc<Asiakas>('asiakkaat/' + laskunAsiakas.avain)
      .listenSnap()
      .pipe(
        map(snapshot => {
          const asiakas = snapshot.data() as Asiakas
          if (asiakas) {
            asiakas.avain = snapshot.id
            return asiakas
          }
          return null
        }),
      )
  }

  validoiPeppolOsoite(osoite: string, kieli: TuettuKieli): Promise<PeppolValidaatioTulos> {
    if (!osoite) {
      return Promise.resolve({ error: true, message: this.translationService.lokalisoi('lasku.peppol-validaatio.osoite-eivalidi', kieli) })
    }

    const address: PeppolNumberRequest = { osoite: this.stringService.removeAllWhiteSpaces(osoite) }
    return this._firebase
      .functionsCall<PeppolNumberRequest, PeppolNumberResponse>('validatePeppolAddress', address)
      .then(response => {
        if (response && response.matches && response.matches.length > 0) {
          const entities = response.matches.flatMap(match => match.entities ?? [])
          if (entities.length === 1) {
            const entity = entities[0]
            const name = this._getPeppolEntityName(entity)
            return { error: false, message: this.translationService.lokalisoi('lasku.peppol-validaatio.osoite-kuuluu', kieli, { nimi: name, maa: entity.countryCode }) }
          } else {
            const multipleResults = entities
              .map(entity => {
                const name = this._getPeppolEntityName(entity)
                return `${name} ${entity.countryCode}`
              })
              .join(', ')
            return { error: false, message: this.translationService.lokalisoi('lasku.peppol-validaatio.loytyi-yritykset', kieli, { yritykset: multipleResults }) }
          }
        } else {
          return { error: true, message: this.translationService.lokalisoi('lasku.peppol-validaatio.osoite-eivalidi', kieli) }
        }
      })
      .catch(error => {
        console.error(error)
        return { error: true, message: this.translationService.lokalisoi('lasku.peppol-validaatio.osoite-eivalidi', kieli) }
      })
  }

  private _getPeppolEntityName(entity: PeppolNumberResponseEntity): string {
    if (Array.isArray(entity.name)) {
      const arr = entity.name as Array<PeppolNameObject>
      if (arr.length > 0) {
        return arr[0].name
      }
    } else if (this.stringService.isString(entity.name)) {
      return entity.name as string
    }

    return ''
  }
}
